module.exports = __webpack_public_path__ + "media/enkonomiya_battle_theme.1fc43b3e.mp3";